'use client';

import { c as _c } from "react/compiler-runtime";
import { Switch } from '@common/components';
import { SvgAlarm } from '@common/icon';
import { useAuthStore } from '@/stores/AuthStore';
import { useAcceptMarketingConsent } from '../../_hooks/useAcceptMarketingConsent';

//* 마케팅 수신동의(marketingMessageReceiveYN)를 읽어 로그인·미동의 회원에게만 노출한다.
//* 동의 뮤테이션은 useAcceptMarketingConsent 공용 훅으로, S8 동의 시트와 동일하게
//* master + 3채널(앱푸시·이메일·SMS)을 함께 켜 두 진입점의 동의 상태를 일치시킨다.
export const AttendanceNotificationRow = () => {
  const $ = _c(7);
  const isLogin = useAuthStore(_temp);
  const myInfo = useAuthStore(_temp2);
  const {
    mutate
  } = useAcceptMarketingConsent();
  if (!isLogin || !myInfo || myInfo.notificationOptions.marketingMessageReceiveYN) {
    return null;
  }
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SvgAlarm className="size-36" originalFill={true} />;
    t1 = <p className="flex-1 font-700 text-Gray-900 typo-body4">출석체크 알림받기</p>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== mutate) {
    t2 = () => mutate();
    $[2] = mutate;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== myInfo.notificationOptions.marketingMessageReceiveYN || $[5] !== t2) {
    t3 = <section className="flex items-center gap-8 bg-Gray-white px-20 py-16 xl:rounded-medium xl:border xl:border-Gray-100">{t0}{t1}<Switch checked={myInfo.notificationOptions.marketingMessageReceiveYN} size="large" onChange={t2} /></section>;
    $[4] = myInfo.notificationOptions.marketingMessageReceiveYN;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
function _temp(state) {
  return state.isLogin;
}
function _temp2(state_0) {
  return state_0.myInfo;
}